import { NCRBaseButtonProps } from 'src/common/components/base-button/base-button';
import React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface HomeMenuPanelItemLabelProps {
  className: string;
  code: string;
}

type HomeMenuPanelItemButtonProps = NCRBaseButtonProps;

export interface HomeMenuPanelItemProps {
  key: string;
  label: HomeMenuPanelItemLabelProps;
  button: HomeMenuPanelItemButtonProps;
}

const HomeMenuPanelItem = (props: HomeMenuPanelItemProps): JSX.Element => {
  const { t } = useTranslation();
  const { key, button, label } = props;
  return (
    <Grid key={key} item xs={12}>
      <Button {...button}>
        <Typography className={label.className}>{t(label.code)}</Typography>
      </Button>
    </Grid>
  );
};

export default HomeMenuPanelItem;
